"use strict";

exports.__esModule = true;
exports.AggregateProvider = void 0;
var _rxjs = require("rxjs");
var _operators = require("rxjs/operators");
class AggregateProvider {
  constructor(_ref) {
    let {
      market,
      dex
    } = _ref;
    this.marketPriceProvider = void 0;
    this.dexPriceProvider = void 0;
    this.marketPriceProvider = market;
    this.dexPriceProvider = dex;
  }
  subscribe(token) {
    // query market price first, try to query price from dex when the market price is zero
    const marketPriceProvider = this.marketPriceProvider;
    const dexPriceProvider = this.dexPriceProvider;
    if (!marketPriceProvider) {
      return dexPriceProvider.subscribe(token);
    }
    const marketPrice$ = marketPriceProvider.subscribe(token);
    return marketPrice$.pipe((0, _operators.switchMap)(result => {
      if (result.isZero()) {
        return dexPriceProvider.subscribe(token);
      }
      return (0, _rxjs.of)(result);
    }));
  }
  async query(currency) {
    return (0, _rxjs.firstValueFrom)(this.subscribe(currency));
  }
}
exports.AggregateProvider = AggregateProvider;